import styled from "styled-components";
import { breakpoint } from "shared/styles/constants";

export const StyledSummary = styled.div`
  width: 100%;

  ${breakpoint("m", "up")} {
    width: 300px;
  }
`;
